import qs from "qs";
import { isWidenImage } from "helpers";
import * as APPLICATIONS from 'constants/applications';

export function matchApplicationHash(hash) {
    const pattern = `${APPLICATIONS.INTERNAL}|${APPLICATIONS.EXTERNAL}`;
    const matches = hash.match(pattern);
    return matches;
}

export function createCommaSeparatedQueryArg(name, values) {
    const queryArgs = [values].filter(v => v).join(",");
    return queryArgs.length ? `${name}=${queryArgs}` : "";
}

export function getFiltersFromSearch(location) {
    const q = qs.parse(location.search.slice(1));
    const filters = q.filters ? q.filters.split(",") : [];
    return filters;
}

export function moveVideosToBottom(images) {
    let imagesThatAreReallyVideos = [];

    const onlyImages = images.filter(function(image) {
        if (isWidenImage(image.image)) {
            imagesThatAreReallyVideos.push(image);
            return false;
        }
        return true;
    });

    return imagesThatAreReallyVideos.concat(onlyImages);
}
